import { render, staticRenderFns } from "./TicketsListComp.vue?vue&type=template&id=6d7b6a53&scoped=true&"
import script from "./TicketsListComp.vue?vue&type=script&lang=js&"
export * from "./TicketsListComp.vue?vue&type=script&lang=js&"
import style0 from "./TicketsListComp.vue?vue&type=style&index=0&id=6d7b6a53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7b6a53",
  null
  
)

export default component.exports